import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getTransactionsAllocateList } from '@store/INV/Transactions/InvAllocate/InvAllocateSlice';

const useGetInvAllocateList = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // if (InvAllocateList?.length === 0) {
      dispatch(getTransactionsAllocateList());
    // }
  }, []);
  const { InvAllocateList, loading, error } = useAppSelector(state => state.InvAllocate);

  return { InvAllocateList, loading, error };
};

export default useGetInvAllocateList;
